<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.THEME' | translate }}</label>
      <mat-radio-group class="flex-col" [formControl]="userThemeFormControl">
        <mat-radio-button [value]="theme.LIGHT">
          {{ themeString[theme.LIGHT] }}
        </mat-radio-button>
        <mat-radio-button [value]="theme.DARK">
          {{ themeString[theme.DARK] }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [disabled]="userThemeFormControl.invalid"
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
